export const formSubmmitMapper = (data) => ({
  id_item_sumber_daya: data?.idItemSumberDaya,
  no_coa: data?.noCoa,
});
